import { Box } from "@mui/material";
import React, { useState, useRef } from "react";
import MaintanenceTable from "./MaintanenceTable";
import { getUserMaintanenceData, uploadUserRoles } from "../Redux/UserMaintanence";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { ColorButton } from "./AdminTable";
import AddUser from "./AddUser";
import "./User.css";
import "./UserMaintaneneceContent.css";
function UserMaintaneneceContent() {
  const dispatch = useDispatch();
  const [openEdit, setOpenEdit] = React.useState(false);
  const initData = useSelector(state => state.userRoles.UserMaintanenceData);
  const [isAlertSec, setisAlertSec] = React.useState(false);
  useEffect(() => {
    dispatch(getUserMaintanenceData());
  }, []);
  const handleOpenAdd = () => {
    setOpenEdit(true);
  };
  const [file, setFile] = useState("");
  const ref = useRef();
  const saveFile = e => {
    setFile(e.target.files[0]);
  };
  const uploadFile = () => {
    const formData = new FormData();
    formData.append("file", file);
    dispatch(uploadUserRoles(formData));
  };
  return <Box>            

      {/* <Stack direction={"row"} spacing={2} sx={{ marginBottom: "30px" }}>
       <div
       className="file-upload"
       style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
       >
          <input
       type="file"
       className="mainData"
       accept=".xlsx"
       ref={ref}
       id="file"
       onChange={saveFile}
       hidden
       />
       <label for="file" className="custom-upload-btn">
       Select File
       </label>
       <span className="file_caption">
       {file.name != undefined && file.name != null ? file.name : "No File Selected"}
       </span>
       </div>
       <Button
       sx={{
       border: "solid 1px #7500C0",
       color: "#7500C0",
       textTransform: "none",
       height: "35px",
       width: "90px",
       }}
       onClick={uploadFile}
       >
       Upload
       </Button> */}

      {/* <ColorButton
       sx={{
       border: "solid 1px #7500C0",
       background: "#7500C0",
       color: "white",
       textTransform: "none",
       height: "35px",
       width: "90px",
       }}
       onClick={sendAdminMail}
       >
       Submit
       </ColorButton> */}
      {/* </Stack> */}
      {/* {isAlertSec ? (
        <Alert
          severity={1 == 1 ? "success" : "error"}
          style={{
            maxWidth: "fit-content",
            position: "absolute",
            top: "419px",
            right: "0px",
            backgroundColor: 1 == 1 ? "#05f0a5" : "#ff3246",
            color: "white",
          }}
          onClose={() => {
            setisAlertSec(false);
          }}
        >
          "Role Updated Successfully !"
        </Alert>
       ) : null} */}
      <div className="maintainPlusAdd migrated-style-usermaintanenececontent-c58887-1">
        <Box sx={{
        width: "95%",
        display: "flex",
        justifyContent: "end",
        position: "absolute",
        padding: '0px 24px 24px 24px !important'
        // top: "3%",
      }}>
          <ColorButton variant="contained" className="cancel-button" size="small" onClick={handleOpenAdd} sx={{
          "background-color": "white",
          "color": "black",
          "border": "2px solid blueviolet",
          "border-radius": "18px",
          "text-transform": "capitalize",
          "padding": "5px 29px",
          "font-weight": "600",
          "font-size": "14px"
        }}>
            Add User
          </ColorButton>
        </Box>
        <Box sx={{
        width: "100%"
      }}>
          <MaintanenceTable isAlertSec={isAlertSec} setisAlertSec={setisAlertSec} initData={initData}
        // filteredData={filteredData}
        // setFilteredData={setFilteredData}
        />
        </Box>
        <AddUser openEdit={openEdit} setOpenEdit={setOpenEdit} initData={initData} />
      </div>
    </Box>;
}
export default UserMaintaneneceContent;
